import { useState } from 'react';

import { Select, TextField } from "@king-ict/eupisi-ui/components";
import { ValidationObject } from "@king-ict/eupisi-ui/hooks";
import { codeBookToSelectData, nameof } from '@king-ict/eupisi-ui/utils';
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { Institution } from '../../models/Institution';
import { Founder } from "../../models/Institution/Founder";
import { useGetCommercialCourtsQuery } from "../../queries/codeBookQuery";
import { institutionDetailsRoute, institutionEditRoute } from "../../routes/routes";
import styles from "./Institution.module.scss";

type FounderProps = {
  founderData: Founder,
  panelIndex: number,
  readOnly: boolean
  errors?: ValidationObject<Institution> | undefined,
}

export default function FounderPanel({ founderData, panelIndex, readOnly, errors }: FounderProps): JSX.Element {
  const [founder, setFounder] = useState<Founder>(founderData);
  const history = useHistory();
  const { t } = useTranslation();
  const { data: commercialCourts } = useGetCommercialCourtsQuery();

  var institutionRoute = readOnly ? institutionDetailsRoute : institutionEditRoute;

  const getNestedArrayError = (index: number, arrayName: string) => (propertyName: string) => {
    var errorObject = errors as Object;
    if (errorObject && errorObject.hasOwnProperty(`${arrayName}${index}`)) {
      return t("validations.required");
    }
    return undefined;
  }

  const handleCommercialCourtChange = (event: any) => {
    founder.commercialCourt = parseInt(event.target.value);
    setFounder(founder);
    history.push(institutionRoute());
  };

  var founderCommercialCourtCol;

  if (readOnly) {
    founderCommercialCourtCol =
      <Col md={4}>
        <TextField
          plaintext
          label={t("institution.commercialCourt")}
          readonly
          value={founder.commercialCourtName}
          className={styles.textFieldLabel}
        />
      </Col>
  }
  else {
    founderCommercialCourtCol =
      <Col md={4}>
        <Select
          label={t("institution.commercialCourt")}
          name={nameof<typeof founder>("commercialCourt")}
          value={founder.commercialCourt}
          onChange={handleCommercialCourtChange}
          selectData={codeBookToSelectData(commercialCourts)}
          errorText={getNestedArrayError(panelIndex, "founders")("commercialCourt")}
          className={styles.textFieldLabel}
        />
      </Col>
  }

  return (
    <>
      <Row className={styles.founderRow}>
        <Col md={4}>
          <TextField
            plaintext
            label={t("institution.founderName")}
            readonly
            value={founder.name}
            className={styles.textFieldLabel}
          />
        </Col>
        <Col md={4}>
          <TextField
            plaintext
            label={t("institution.founderOib")}
            readonly
            value={founder.oib}
            className={styles.textFieldLabel}
          />
        </Col>
        <Col md={4}>
          <TextField
            plaintext
            label={t("institution.founderMbs")}
            readonly
            value={founder.mbg}
            className={styles.textFieldLabel}
          />
        </Col>
      </Row>
      <Row className={styles.founderRow}>
        {founderCommercialCourtCol}
      </Row>
    </>
  );
}